import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledErrorScreen } from './styles/StyledErrorScreen';


class ErrorScreen extends Component {
  render() {
    const { title, textSize } = this.props;

    return (
      <StyledErrorScreen
        textSize={textSize}
      > 
        <div className="error-container" role="status">
          <div className="error-content">
            <div className="error-icon">
              <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
            </div>
            <div className="error-title">
              { title }  
            </div> 
          </div>  
        </div>      
      </StyledErrorScreen>
    );
  }
}


ErrorScreen.defaultProps = {
  title: 'Nepodařilo se načíst data. Zkuste prosím stránku načíst znovu, nebo opakujte akci později.',
  textSize: 1,
};


ErrorScreen.propTypes = {
  title: PropTypes.string,
  textSize: PropTypes.number,
};


export default ErrorScreen;